<div class="dialog-container">
    <div class="dialog-header">
        
        <div class="header-info">
            <div class="info-item">
                <span class="label">Embarcação:</span>
                <span class="value">{{boatName}}</span>
            </div>
            <div class="info-item">
                <span class="label">Pacote:</span>
                <span class="value">{{packageName}}</span>
            </div>
        </div>
        
    </div>

    <div class="dialog-content">
        <div class="consumption-cards" *ngIf="consumptionHistory.length > 0">
            <div class="consumption-card" *ngFor="let item of consumptionHistory">
                <div class="card-header">
                    <div class="order-info">
                        <h3 class="product-name">{{item.productName}}</h3>
                        <div class="order-details">
                            <span class="order-number">Pedido: {{item.orderNumber}}</span>
                            <span class="order-date">{{formatDateTime(item.orderDate)}}</span>
                        </div>
                    </div>
                    <div class="employee-info">
                        <span class="employee">{{item.employeeName}}</span>
                    </div>
                </div>

                <div class="card-body">
                    <div class="consumption-details">
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="label">Quantidade Fornecida:</span>
                                <span class="value">{{item.qtySupplied}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">Valor Unitário:</span>
                                <span class="value">{{formatCurrency(item.itemValue)}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">Desconto:</span>
                                <span class="value">{{formatCurrency(item.discount)}}</span>
                            </div>
                        </div>
                        
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="label">Data do Fornecimento:</span>
                                <span class="value">{{formatDateTime(item.dateSupply)}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">Marina:</span>
                                <span class="value">{{item.marinaName}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer">
                    <div class="total-info">
                        <span class="label">Total:</span>
                        <span class="value">{{formatCurrency(item.itemTotal)}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="empty-state" *ngIf="consumptionHistory.length === 0">
            <i class="pi pi-info-circle"></i>
            <h3>Nenhum histórico de consumo encontrado</h3>
        </div>
    </div>
</div>